import Dispatcher from '../../dispatcher';
import { actions } from '../../constants/sidebar/actions';

export const showQuantityAndPriceRow = () =>
    Dispatcher.handleSidebarAction({ type: actions.SHOW_QUANTITY_AND_PRICE });

export const hideQuantityAndPriceRow = () =>
    Dispatcher.handleSidebarAction({ type: actions.HIDE_QUANTITY_AND_PRICE });
